import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION } from './lending-equipment-uses-volume-by-product-list-chart.definition';
import { LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA } from './lending-equipment-uses-volume-by-product-list-chart.mock';

export const LendingEquipmentUsesVolumeByProductListChart = (props: ListChartProps) => <ListChart {...props} />;

LendingEquipmentUsesVolumeByProductListChart.definition = LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST_CHART_DEFINITION;
LendingEquipmentUsesVolumeByProductListChart.mockData = LENDING_EQUIPMENT_USES_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA;
